import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "class-box-header is-domain" }
const _hoisted_3 = { class: "class-box-title" }
const _hoisted_4 = { class: "class-box-compartment" }
const _hoisted_5 = { class: "class-box-markers" }
const _hoisted_6 = { class: "class-box-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "class-box is-domain-box",
    style: _normalizeStyle(_ctx.style),
    role: "button",
    tabindex: "0",
    title: _ctx.$tt('domain-design-named', {domain: _ctx.domain.name}),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open'))),
    onKeydown: [
      _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('open')), ["enter"])),
      _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('open')), ["prevent"]), ["space"]))
    ]
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, {
        size: "small",
        start: "",
        color: "white"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("mdi-format-list-bulleted", -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.domain.name), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.domain.options, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          key: option.id,
          class: "class-box-row"
        }, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_v_icon, {
              size: "x-small",
              color: option.color
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-circle-medium", -1)
              ]))]),
              _: 1
            }, 8, ["color"])
          ]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(option.name), 1)
        ]))
      }), 128))
    ])
  ], 44, _hoisted_1))
}